// extracted by mini-css-extract-plugin
export default {"statisticsCard":"style_statisticsCard__wlMjr","statisticNumber":"style_statisticNumber__x9Szu","statisticLabel":"style_statisticLabel__kahEX","cursor":"style_cursor__xLdoK"};